module.exports = __webpack_public_path__ + "media/images/favicon-d0e217a23902fb436d804408e8820542.ico";